import ModuleChip from '../../components/ModuleChip.js';
import RepoBadge from '../../components/RepoBadge.js';
import type { PrRegistryRow } from '../../api.js';
import { useOpenPrs } from './useOpenPrs.js';

function ageLabel(hours: number): string {
  if (hours < 1) return '<1h';
  if (hours < 24) return `${hours}h`;
  return `${Math.floor(hours / 24)}d`;
}

function prUrl(row: PrRegistryRow): string {
  return `https://github.com/${row.repo}/pull/${row.pr_number}`;
}

function OpenPrRow({ row }: { row: PrRegistryRow }) {
  const isOrphan = row.track_id === null;
  return (
    <div className="request-row" key={`${row.repo}#${row.pr_number}`}>
      <div className="request-row-main">
        <div className="request-row-title">
          <RepoBadge targetRepo={row.repo} /> <ModuleChip module={row.module} />{' '}
          <a href={prUrl(row)} target="_blank" rel="noreferrer">
            #{row.pr_number} {row.title}
          </a>
        </div>
        <div className="request-row-chips">
          <span className={`pr-lane-chip${isOrphan ? ' pr-lane-chip-orphan' : ''}`}>{row.origin}</span>
          {row.verdicts?.review_verdict && (
            <span className="verdict-chip" data-verdict={row.verdicts.review_verdict}>
              CTO {row.verdicts.review_verdict}
            </span>
          )}
          {row.verdicts?.ciso_verdict && (
            <span className="verdict-chip" data-verdict={row.verdicts.ciso_verdict}>
              CISO {row.verdicts.ciso_verdict}
            </span>
          )}
          <span className="pr-age">{ageLabel(row.age_hours)}</span>
        </div>
        <div className="request-row-note">{row.status_hint}</div>
      </div>
    </div>
  );
}

export default function OpenPrsCard() {
  const { rows, loading, error } = useOpenPrs();

  return (
    <div className="conductor-card">
      <div className="conductor-card-header">
        <span className="conductor-card-title">Open PRs</span>
        <span className="conductor-card-subtitle">{rows.length} open</span>
      </div>
      {loading && <div className="empty">Loading…</div>}
      {error && <div className="empty">{error}</div>}
      {!loading && !error && (
        <div className="requests-list">
          {rows.length === 0 && <div className="empty">No open PRs.</div>}
          {rows.map((row) => (
            <OpenPrRow row={row} key={`${row.repo}#${row.pr_number}`} />
          ))}
        </div>
      )}
    </div>
  );
}
